export default __webpack_public_path__ + "static/media/checkmark.192ae054.svg";